module.exports = __webpack_public_path__ + "static/img/4.89fd438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/4.jpg
// module id = G/zS
// module chunks = 1